<template>
  <div class="login-container">
    <!-- 背景 -->
    <div class="background-wrapper">
      <div class="bg-image"></div>
      <div class="bg-overlay"></div>
    </div>
    
    <!-- 登录卡片 -->
    <div class="login-card">
      <div class="login-header">
        <h1 class="title">Play Spider</h1>
        <p class="subtitle">Welcome back</p>
      </div>
      
      <el-form
        :model="loginReq"
        ref="loginForm"
        :rules="rules"
        class="login-form"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        element-loading-text="Logging in..."
      >
        <el-form-item prop="account" class="form-item">
          <el-input
            v-model="loginReq.account"
            type="text"
            :prefix-icon="Avatar"
            placeholder="Username"
            class="custom-input"
            :validate-event="false"
          />
        </el-form-item>
        
        <el-form-item prop="password" class="form-item">
          <el-input
            v-model="loginReq.password"
            type="password"
            :prefix-icon="Lock"
            placeholder="Password"
            class="custom-input"
            show-password
            :validate-event="false"
          />
        </el-form-item>
        
        <div class="form-actions">
          <el-button
            type="primary"
            class="login-btn"
            @click="handleLogin"
            :loading="loading"
          >
            Sign In
          </el-button>
          
          <el-button
            type="text"
            class="register-btn"
            @click="handleRegister"
          >
            Create Account
          </el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { setRole } from "../utils/permission";
import { login } from "../api/user";
import { setLoginInfo } from "../utils/auth";
import { getQueryString } from "../utils/url";
import { Avatar, Lock } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";

export default {
  name: "Login",
  data() {
    return {
      Avatar,
      Lock,
      loading: false,
      loginReq: {
        account: "",
        password: "",
      },
      rules: {
        account: [
          {
            required: true,
            message: "Username is required",
            trigger: ["blur", "change"]
          },
          {
            max: 64,
            message: "Username cannot exceed 64 characters",
            trigger: "blur"
          }
        ],
        password: [
          {
            required: true,
            message: "Password is required",
            trigger: ["blur", "change"]
          },
          {
            min: 6,
            message: "Password must be at least 6 characters",
            trigger: "blur"
          },
          {
            max: 20,
            message: "Password cannot exceed 20 characters",
            trigger: "blur"
          }
        ]
      }
    };
  },
  mounted() {
    // 添加页面加载动画
    this.$nextTick(() => {
      setTimeout(() => {
        const card = document.querySelector('.login-card');
        if (card) {
          card.classList.add('animate-in');
        }
      }, 100);
    });
  },
  methods: {
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          
          // 添加表单提交动画
          const form = document.querySelector('.login-form');
          if (form) {
            form.classList.add('submitting');
          }
          
          login({
            account: this.loginReq.account,
            password: this.loginReq.password
          })
            .then((response) => {
              setTimeout(() => {
                setLoginInfo(response.data.data);
                setRole(response.data.data.id, response.data.data.role);
                this.loading = false;
                
                // 登录成功动画
                if (form) {
                  form.classList.remove('submitting');
                  form.classList.add('success');
                  ElMessage.success("登录成功");
                }
                
                setTimeout(() => {
                  const redirectUrl = getQueryString("redirect");
                  if (redirectUrl) {
                    this.$router.push(redirectUrl);
                  } else {
                    this.$router.push({ name: "appList" });
                  }
                }, 600);
              }, 500);
            })
            .catch((err) => {
              console.log(err);
              this.loading = false;
              
              // 登录失败动画
              if (form) {
                form.classList.remove('submitting');
                form.classList.add('error');
                setTimeout(() => {
                  form.classList.remove('error');
                }, 1500);
              }
            });
        } else {
          // 表单验证失败动画
          const form = document.querySelector('.login-form');
          if (form) {
            form.classList.add('validation-error');
            setTimeout(() => {
              form.classList.remove('validation-error');
            }, 800);
          }
          return false;
        }
      });
    },
    
    handleRegister() {
      // 添加平滑过渡效果
      const card = document.querySelector('.login-card');
      if (card) {
        card.classList.add('animate-out');
        setTimeout(() => {
          this.$router.push({ name: "register" });
        }, 300);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$primary-color: #0077ed;
$primary-hover: #0056b3;
$background-overlay: rgba(0, 0, 0, 0.7);
$card-bg: rgba(255, 255, 255, 0.15);
$border-radius: 16px;
$shadow: 0 8px 32px rgba(31, 38, 135, 0.2);
$transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

.login-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.background-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  
  .bg-image {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: url("../assets/login-background.jpg");
    background-size: cover;
    background-position: center;
    filter: brightness(0.7);
    transform: scale(1.05);
    animation: bgZoom 20s infinite alternate;
  }
  
  .bg-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.4) 100%);
    backdrop-filter: blur(10px);
  }
}

.login-card {
  position: relative;
  z-index: 10;
  width: 100%;
  max-width: 420px;
  padding: 40px;
  background: $card-bg;
  border-radius: $border-radius;
  box-shadow: $shadow;
  transform: translateY(30px);
  opacity: 0;
  transition: $transition;
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  background-clip: padding-box;
  position: relative;
  overflow: hidden;
  
  // 液态玻璃效果增强 - 内部发光效果
  &::before {
    content: '';
    position: absolute;
    top: -10px;
    left: -10px;
    right: -10px;
    bottom: -10px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
    filter: blur(2px);
    z-index: -1;
    border-radius: $border-radius;
  }
  
  // // 动态光影效果
  // &::after {
  //   content: '';
  //   position: absolute;
  //   top: -50%;
  //   left: -50%;
  //   width: 200%;
  //   height: 200%;
  //   border-radius: 50%;
  //   background: linear-gradient(45deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  //   animation: liquidFlow 8s ease-in-out infinite;
  //   z-index: 0;
  // }
  
  &.animate-in {
    transform: translateY(0);
    opacity: 1;
  }
  
  &.animate-out {
    transform: translateY(-30px);
    opacity: 0;
  }
  
  @media (max-width: 768px) {
    margin: 0 20px;
    padding: 30px 25px;
  }
}

.login-header {
  text-align: center;
  margin-bottom: 30px;
  
  .logo-container {
    margin-bottom: 20px;
    
    .logo {
      width: 80px;
      height: 80px;
      object-fit: contain;
      border-radius: 16px;
      transition: transform 0.3s ease;
      
      &:hover {
        transform: scale(1.05) rotate(5deg);
      }
    }
  }
  
  .title {
    font-size: 28px;
    font-weight: 700;
    margin: 0 0 8px 0;
    background: linear-gradient(135deg, #3a1c71, #d76d77, #ffaf7b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  
  .subtitle {
    font-size: 16px;
    color: rgba(255, 255, 255, 0.85);
    margin: 0;
    font-weight: 400;
  }
}

.login-form {
  position: relative;
  z-index: 1;
  transition: $transition;
  
  &.submitting {
    transform: scale(0.98);
  }
  
  &.success {
    transform: scale(1.02);
  }
  
  &.error {
    animation: shake 0.5s ease-in-out;
  }
  
  &.validation-error {
    animation: shake 0.6s ease-in-out;
  }
}

.form-item {
  margin-bottom: 22px;
  transition: $transition;
  
  .custom-input {
    width: 100%;
    transition: $transition;
    
    :deep(.el-input__wrapper) {
        border-radius: 10px;
        border: 1px solid rgba(255, 255, 255, 0.3);
        background-color: rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(10px);
        transition: $transition;
        
        &:focus-within {
          border-color: $primary-color;
          box-shadow: 0 0 0 3px rgba(0, 119, 237, 0.1);
          border-width: 1px;
        }
        
        &:hover {
          border-color: #cbd5e1;
        }
      }
    
    :deep(.el-input__inner) {
      border: none;
      padding: 12px 16px;
      font-size: 15px;
      height: 48px;
      color: #dddddd;
      
      &::placeholder {
        color: #dddddd;
      }
    }
    
    :deep(.el-input__prefix) {
      left: 12px;
      
      .el-icon {
        color: #dddddd;
        font-size: 18px;
      }
    }
    
    :deep(.el-input__suffix) {
      right: 12px;
      
      .el-icon {
        color: #dddddd;
        font-size: 18px;
        cursor: pointer;
        
        &:hover {
          color: $primary-color;
        }
      }
    }
  }
}

.form-actions {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 30px;
}

.login-btn {
  width: 100%;
  height: 48px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  background-color: $primary-color;
  border: none;
  transition: $transition;
  position: relative;
  overflow: hidden;
  
  &:hover:not(:disabled) {
    background-color: $primary-hover;
    transform: translateY(-1px);
    box-shadow: 0 8px 25px rgba(0, 119, 237, 0.3);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.3);
    transform: translate(-50%, -50%);
    transition: width 0.6s, height 0.6s;
  }
  
  &:active::before {
    width: 300px;
    height: 300px;
  }
}

.register-btn {
  width: 100%;
  height: 44px;
  font-size: 15px;
  font-weight: 500;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(5px);
  transition: $transition;
  margin: 0;
  
  &:hover {
    color: $primary-color;
    border-color: $primary-color;
    background-color: rgba(0, 119, 237, 0.05);
  }
}

// Animations
@keyframes liquidFlow {
  0% {
    transform: rotate(0deg) translate(-50%, -50%);
  }
  100% {
    transform: rotate(360deg) translate(-50%, -50%);
  }
}

@keyframes bgZoom {
  0% {
    transform: scale(1.05);
    filter: brightness(0.7) saturate(1);
  }
  100% {
    transform: scale(1.15);
    filter: brightness(0.8) saturate(1.2);
  }
}

@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  20%, 60% {
    transform: translateX(-8px);
  }
  40%, 80% {
    transform: translateX(8px);
  }
}

// Global styles to ensure full height
:global(html),
:global(body) {
  height: 100%;
  margin: 0;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

:global(#app) {
  height: 100%;
}
</style>